import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ExcelUpload } from "./ExcelUpload";
import { MailingRecordsTable } from "./MailingRecordsTable";
import { DuplicateReview } from "./DuplicateReview";
import { MelissaImport } from "./MelissaImport";
import { MailingQueryExport } from "./MailingQueryExport";
import { BusinessMailingExport } from "./BusinessMailingExport";
import { MailMergeExport } from "./MailMergeExport";

import { CommitSummaryCard } from "./CommitSummaryCard";
import { ConsiderationPurgeReview } from "./ConsiderationPurgeReview";
import { FileSpreadsheet, Table as TableIcon, Copy, ShieldCheck, Download, MessageSquareText, DollarSign, UserCheck } from "lucide-react";
import { PrefixAutoAssign } from "./PrefixAutoAssign";
import { BuncombeCountyImport } from "./BuncombeCountyImport";


export default function MailingRecordsPage() {
  const [refreshKey, setRefreshKey] = useState(0);
  const [activeTab, setActiveTab] = useState("records");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Mailing Records</h1>
        <p className="text-muted-foreground">Manage your seller mailing database</p>
      </div>

      <CommitSummaryCard />

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="records" className="flex items-center gap-1.5">
            <TableIcon className="h-4 w-4" /> Records
          </TabsTrigger>
          <TabsTrigger value="duplicates" className="flex items-center gap-1.5">
            <Copy className="h-4 w-4" /> Duplicates
          </TabsTrigger>
          <TabsTrigger value="import" className="flex items-center gap-1.5">
            <FileSpreadsheet className="h-4 w-4" /> Import
          </TabsTrigger>
          <TabsTrigger value="melissa" className="flex items-center gap-1.5">
            <ShieldCheck className="h-4 w-4" /> Melissa Import
          </TabsTrigger>
          <TabsTrigger value="export" className="flex items-center gap-1.5">
            <Download className="h-4 w-4" /> Export
          </TabsTrigger>
          <TabsTrigger value="mail-merge" className="flex items-center gap-1.5">
            <MessageSquareText className="h-4 w-4" /> Mail Merge
          </TabsTrigger>
          <TabsTrigger value="purge-review" className="flex items-center gap-1.5">
            <DollarSign className="h-4 w-4" /> Purge Review
          </TabsTrigger>
          <TabsTrigger value="prefixes" className="flex items-center gap-1.5">
            <UserCheck className="h-4 w-4" /> Prefixes
          </TabsTrigger>
        </TabsList>

        <TabsContent value="records">
          <MailingRecordsTable refreshKey={refreshKey} />
        </TabsContent>



        <TabsContent value="duplicates">
          <DuplicateReview onComplete={() => { setRefreshKey(k => k + 1); setActiveTab("records"); }} />
        </TabsContent>

        <TabsContent value="import">
          <div className="space-y-6">
            <ExcelUpload onImportComplete={() => setRefreshKey(k => k + 1)} />
            <BuncombeCountyImport onImportComplete={() => setRefreshKey(k => k + 1)} />
          </div>
        </TabsContent>

        <TabsContent value="melissa">
          <MelissaImport onImportComplete={() => setRefreshKey(k => k + 1)} />
        </TabsContent>

        <TabsContent value="export">
          <MailingQueryExport />
          <BusinessMailingExport />
        </TabsContent>

        <TabsContent value="mail-merge">
          <MailMergeExport />
        </TabsContent>

        <TabsContent value="purge-review">
          <ConsiderationPurgeReview onComplete={() => { setRefreshKey(k => k + 1); setActiveTab("records"); }} />
        </TabsContent>

        <TabsContent value="prefixes">
          <PrefixAutoAssign onComplete={() => setRefreshKey(k => k + 1)} />
        </TabsContent>
      </Tabs>
    </div>
  );
}